import { render, staticRenderFns } from "./ms-check-msg.vue?vue&type=template&id=e81bd518&scoped=true"
import script from "./ms-check-msg.vue?vue&type=script&lang=js"
export * from "./ms-check-msg.vue?vue&type=script&lang=js"
import style0 from "./ms-check-msg.vue?vue&type=style&index=0&id=e81bd518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81bd518",
  null
  
)

export default component.exports